<div class="dropdown-wrapper">
    <div class="dropdown-select" (click)="toggleDropdown()">
        <img
            *ngIf="selected"
            [src]="selected.img"
            [alt]="selected.name"
            class="selected-img"
        />
        <span *ngIf="!selected">{{'words.select-a-badge' | translate}}</span>
        <span *ngIf="selected">{{ selected.name | translate }}</span>
        <span class="arrow">&#9662;</span>
    </div>

    <div class="dropdown-menu" *ngIf="dropdownOpen">
        <div
            class="dropdown-item"
            *ngFor="let insignia of badges"
            
            (click)="select(insignia)"
        >
            <img [src]="insignia.img" [alt]="insignia.name" />
            <span>{{ insignia.name | translate}}</span>
        </div>
    </div>
</div>
